export default __webpack_public_path__ + "static/media/0x0d98eae620491d8f6836a39ac45e54b286fdd2d7.becd6fcb.png";